import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import ReminderComponent from '../components/ReminderComponent'

const mapStateToProps = (state) => {
  return {
    reminder: state.reminder,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReminderComponent)
